module.exports = __webpack_public_path__ + "img/vertical_7_1_8011.f2720514.png";